"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _Button = require("../../Button/Button");
var _Icon = require("../../Icon/Icon");
var _PaymentError = require("../../PaymentError/PaymentError");
var _payment = require("../../assets/icons/payment");
var _PaymentManualModule = _interopRequireDefault(require("../PaymentManual.module.css"));
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var _default = function _default(_ref) {
  var platform = _ref.platform,
    error = _ref.error,
    timeout = _ref.timeout,
    callback = _ref.callback,
    resendHandler = _ref.resendHandler;
  var _useState = (0, _react.useState)({
      show: false,
      timeout: timeout
    }),
    _useState2 = _slicedToArray(_useState, 2),
    resend = _useState2[0],
    setResend = _useState2[1];
  (0, _react.useEffect)(function () {
    if (resend.timeout) setTimeout(function () {
      return setResend({
        show: true,
        timeout: null
      });
    }, timeout * 1000);
  }, [resend]);
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    as: _reactBootstrap.Form,
    noValidate: true,
    autoComplete: 'off',
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      callback({
        sms: e.target.sms.value
      });
    }
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    xs: platform === 'mob' ? 12 : 5,
    style: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: platform === 'mob' ? 'flex-start' : 'flex-end',
      fontFamily: 'lbet-st',
      fontSize: '1.3rem',
      color: '#868895'
    }
  }, "\u10E8\u10D4\u10D8\u10E7\u10D5\u10D0\u10DC\u10D4\u10D7 SMS \u10D9\u10DD\u10D3\u10D8"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    xs: platform === 'mob' ? 12 : 4
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    className: _PaymentManualModule.default.formGroup
  }, /*#__PURE__*/_react.default.createElement(platform === 'mob' ? _reactBootstrap.FloatingLabel : _react.default.Fragment, _objectSpread({}, platform === 'mob' && {
    label: 'SMS',
    style: {
      width: '100%',
      color: '#868895'
      /*color: !error.sms ? '#868895' : 'var(--bs-danger)',*/
    },

    className: _PaymentManualModule.default.floatingLabel
  }), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    name: 'sms',
    placeholder: 'SMS',
    isInvalid: !!error.sms,
    style: {
      paddingRight: '2.7rem'
    }
  }), resend.show && /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: 'info',
    outline: true,
    style: {
      position: 'absolute',
      right: '0.7rem',
      top: '50%',
      transform: 'translateY(-50%)',
      width: 'fit-content',
      border: 'none',
      background: 'transparent',
      padding: 0
    },
    onClick: function onClick() {
      var _resendHandler = resendHandler(),
        timeout = _resendHandler.timeout;
      setResend({
        show: false,
        timeout: timeout
      });
    }
  }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    height: '2rem',
    width: '2rem',
    type: 'vec',
    Icon: _payment.Resend,
    style: {
      backgroundColor: '#435fa0'
    }
  })))), platform === 'mob' && !!error.sms && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, null, error.sms)), platform === 'web' && /*#__PURE__*/_react.default.createElement(_PaymentError.PaymentError, {
    show: !!error.sms,
    message: error.sms
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    xs: platform === 'mob' ? 12 : 3
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: 'secondary',
    style: {
      backgroundColor: '#3E42B5',
      borderColor: '#3E42B5'
    },
    type: 'submit'
  }, "\u10D3\u10D0\u10E1\u10E2\u10E3\u10E0\u10D8")));
};
exports.default = _default;